import { render, staticRenderFns } from "./purchaseSaleStockSummary.vue?vue&type=template&id=382293c4&scoped=true"
import script from "./purchaseSaleStockSummary.vue?vue&type=script&lang=js"
export * from "./purchaseSaleStockSummary.vue?vue&type=script&lang=js"
import style0 from "./purchaseSaleStockSummary.vue?vue&type=style&index=0&id=382293c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "382293c4",
  null
  
)

export default component.exports